export default "__VITE_ASSET__tYWQo9J0__"